import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Oauth2Client, TokenRequest } from '@benefitsui/app/api/benefits-clients';
import { AuthenticationService } from '@benefitsui/app/services/auth/authentication.service';
import { environment } from '@benefitsui/environments/environment';

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss'],
  standalone: false
})
export class LoginPageComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private oauth2Client: Oauth2Client
  ) {}

  async ngOnInit(): Promise<void> {
    const routeSnapshot = this.route.snapshot;
    const code: string = routeSnapshot.queryParams?.code;
    if (code) {
      console.log('code present in url');
      try {
        const request: TokenRequest = {
          authorizationCode: code,
          clientId: environment.clientId,
          redirectUrl: environment.redirectUrl
        };
        await this.oauth2Client.token(request).toPromise();
        if (routeSnapshot.queryParams.state) {
          const decodedState = decodeURIComponent(routeSnapshot.queryParams.state);
          const state = this.authenticationService.readState(decodedState);
          if (state.returnTo && state.returnTo !== '/') {
            console.log('state present, navigating to custom page');
            this.navigateToPage(state.returnTo);
          } else {
            await this.navigateToHomePage();
          }
        } else {
          console.log('no state present');
          await this.navigateToHomePage();
        }
      } catch (error) {
        console.error('oauth token exchange error', error);
        const status = (error as HttpErrorResponse).status;
        if (status === 400) {
          console.warn('http 400 error, user likely already logged in');
          await this.navigateToHomePage();
        } else {
          console.log(status);
          await this.navigateToHomePage();
        }
      }
    } else if (routeSnapshot.queryParams?.error) {
      console.error('oauth authentication failure', routeSnapshot.queryParams.error);
      await this.navigateToHomePage();
    } else if (sessionStorage.getItem('login_destination_path')) {
      console.log('final destination found from session storage');
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      const path = sessionStorage.getItem('login_destination_path')!;
      sessionStorage.removeItem('login_destination_path');
      try {
        const success = await this.router.navigateByUrl(path);
        if (!success) {
          console.warn('failed to navigate to state from storage');
          await this.navigateToHomePage();
        }
      } catch (error) {
        console.error('error navigating to state from storage', error);
        await this.navigateToHomePage();
      }
    } else {
      console.log('no code, no final destination, going to home page');
      await this.navigateToHomePage();
    }
  }

  private async navigateToPage(path: string): Promise<void> {
    try {
      sessionStorage.setItem('login_destination_path', path);
      await this.router.navigate([path]);
    } catch (error) {
      console.log('error navigating to state', error);
    }
  }

  private async navigateToHomePage(): Promise<void> {
    try {
      await this.router.navigate(['/benefits/search']);
    } catch (error) {
      console.log('error navigating to home page', error);
    }
  }
}
